import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useFirebaseAuth } from '../../hooks';
import { ApiContext, CoreContext, FirebaseContext } from '../../providers';
import { setError } from '../../state';

import { ProfileFormContext } from './context';
import { Button } from '../../components/Button';

/** @type {React.FC} */
export const ButtonsRemoveProfile = () => {
    const { store } = useContext(CoreContext);
    const { Upscore } = useContext(ApiContext);
    const { user } = useContext(FirebaseContext);
    const navigate = useNavigate();
    const { handleSignOutCurrentUser } = useFirebaseAuth();
    const { sectionData, setRemoveProfileState } =
        useContext(ProfileFormContext);
    const {
        deleteConfirmationHeading,
        buttonAbortDeletionLabel,
        buttonConfirmDeletionLabel,
    } = sectionData;

    const handleRemoveProfile = useCallback(async () => {
        try {
            await Upscore.deleteUserProfile().then((response) => {
                if (response.result === true && user) {
                    user.delete()
                        .then(() => {
                            handleSignOutCurrentUser();
                            navigate('/');
                        })
                        .catch((error) => {
                            console.error(error);

                            /**
                             * Firebase delete operation is sensitive and requires recent
                             * authentication. User have to log in again before retrying
                             * this request
                             */
                            if (error.code === 'auth/requires-recent-login') {
                                store.dispatch(
                                    setError('profile-deletion-reauth'),
                                );
                            }
                            // setReauthError(true);
                        });
                }
            });
        } catch (error) {
            store.dispatch(setError('general'));
        }
    }, [handleSignOutCurrentUser, navigate]);

    return (
        <>
            <h4 className="ProfilePage__actions-title">
                {deleteConfirmationHeading}
            </h4>
            <Button
                variant="danger"
                onClick={handleRemoveProfile}
                data-event="profile form (confirm remove button)"
                // disabled={isRemoving}
            >
                {buttonConfirmDeletionLabel}
            </Button>
            <Button
                variant="primary"
                onClick={() => setRemoveProfileState(false)}
                data-event="profile form (abort remove button)"
            >
                {buttonAbortDeletionLabel}
            </Button>
        </>
    );
};
